module.exports = __webpack_public_path__ + "static/img/1.2cc1a25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/zh/1.png
// module id = +fAh
// module chunks = 0